import Media from '@segment/matcha/components/Media';
import MobileNavigation from './MobileNavigation';
import DesktopNavigation from './DesktopNavigation';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return _jsxs(_Fragment, {
    children: [_jsx(Media, {
      greaterThanOrEqual: "md",
      children: _jsx(DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), _jsx(Media, {
      lessThan: "md",
      children: _jsx(MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
export default NavigationBrand;